import dynamic from "next/dynamic";
import { useState, useCallback, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
const Container = dynamic(() => import("./Container"), { ssr: false });

const CountryPopup = ({ handleChangeCountry, currentCountry }) => {
    const [visible, setVisible] = useState(false);
    const onOpenChange = useCallback((val) => {
        setVisible(val);
    }, []);

    const handleCountrySelect = (val) => {
        handleChangeCountry('country', val);
        onOpenChange(false);
    }

    return (
        <Dialog
            open={visible}
            onOpenChange={onOpenChange}
        >
            <DialogTrigger
                asChild
                id=""
            >
                <Button
                    aria-label="search"
                    variant="secondary"
                    className="
                        bg-white hover:bg-white rounded-none 
                        px-2 py-0 h-[45px] border border-slate-300 w-full
                        items-center justify-between cursor-pointer 
                    "
                >
                    <div className="relative">
                        <span className="text-slate-400 text-xs tracking-wide absolute left-0 top-[-12px]">Country/region</span>
                        <span className="text-font-primary text-sm tracking-wide line-clamp-2 text-ellipsis">{currentCountry[1]}</span>
                    </div>
                    <div
                        id={'countryModal'}
                        className="
                            w-[20px] h-[20px] transition 
                            duration-150 ease-out hover:ease-in-out 
                            toggle-down ml-2 accordion-down
                        "
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20px"
                            height="20px"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="
                                    M6.29289 8.79289C6.68342 8.40237 7.31658 
                                    8.40237 7.70711 8.79289L12 13.0858L16.2929 
                                    8.79289C16.6834 8.40237 17.3166 8.40237 
                                    17.7071 8.79289C18.0976 9.18342 18.0976 
                                    9.81658 17.7071 10.2071L12.7071 15.2071C12.3166 
                                    15.5976 11.6834 15.5976 11.2929 15.2071L6.29289 
                                    10.2071C5.90237 9.81658 5.90237 9.18342 6.29289 
                                    8.79289Z
                                "
                                fill="#393939"
                            />
                        </svg>
                    </div>
                </Button>
            </DialogTrigger>
            <Container
                currentCountry={currentCountry}
                handleCountrySelect={handleCountrySelect}
            />
        </Dialog>

    )
}

export default CountryPopup